import React = require("react");
import { IStatus, StatusType } from "../../store";

export interface INotificationBarProps {
    status: IStatus;
}

export const NotificationBar = (props: INotificationBarProps): React.ReactElement<INotificationBarProps> => {
    return (
        props.status && (props.status.type == StatusType.ERROR || props.status.type == StatusType.NORESULTS)
            ?   <div className="wpo ui borderless panel">
                    <div className="wpo ui content table">
                        <h5 className="wpo ui centered">{props.status.statusMessage}</h5>
                    </div>
                </div>
            :   null
    )
};